import { EloNotificationService, SpinnerService } from '@elotech/angular-common';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class ArquivoService {

  constructor(
    private _httpClient: HttpClient,
    private _notificationsService: EloNotificationService,
    private _spinnerService: SpinnerService
  ) { }

  public async downloadFromURL(url, fileName) {
    const arquivo = await this.getArquivo(url);

    if (!arquivo) {
      this._spinnerService.show.emit(false);
      this._notificationsService.error('Arquivo não encontrado', 'Não foi possível localizar o arquivo selecionado.');
      return;
    }

    const blobURL = URL.createObjectURL(new Blob([arquivo]));
    const anchor = document.createElement('a');
    anchor.download = fileName;
    anchor.href = blobURL;
    anchor.click();
    this._spinnerService.show.emit(false);
    this._notificationsService.success('Operação realizada com sucesso', 'Download concluído');
  }

  public getArquivo(url: string): Promise<any> {
    return firstValueFrom(
      this._httpClient.get(url, { responseType: 'blob' })
    );
  }
}
